<template>
  <div>
    <div class="community-banner">
      <div class="desc">
        <div class="desc-content">
          <div class="desc-word">
            <span class="orange">[XR上云] </span>
             <!-- class="main-color" -->
            <span> 总动员</span>
            --
            <span>{{title}}</span>
          </div>

          <el-button class="sign main-bg-color" round size="mini">
            <!--马上报名： http://hdxu.cn/zkTR1 -->
           <a href="https://www.pingxingyun.com/console/#/contribute/detail?topicId=10023&categoryId=3" target="_blank" style="color: white">观看回放</a> </el-button>
        </div>
      </div>

    </div>
    <div class="dev-main ">
      <div class="search clearfix">
        <div class="fl">
          <router-link class="a-tab" :to="{path:'/community/index'}">分类</router-link>
          <el-divider direction="vertical" style="margin: 0 20px"></el-divider>
          <router-link class="a-tab" :to="{path:'/community/index/all'}">一览</router-link>
        </div>

        <el-input placeholder="请输入内容" v-model="searchForm.keyword" class="input-with-select" clearable>
          <!--<el-select v-model="searchForm.type" slot="prepend" >
            <el-option label="标签" value="1"></el-option>
            <el-option label="内容" value="2"></el-option>
          </el-select>-->
          <el-button slot="append" icon="el-icon-search" @click="getCategories"></el-button>
        </el-input>
        <div class="fr">
          <router-link :to="{path: user && user.loginId && user.loginId != null ? '/question/add':'/login'}" style="margin-right: 20px">
            <el-button class="sign main-bg-color">
              <img class="submit-icon" :src="$baseUrl+'img/submit.png'"/>
              <span class="submit-word">提问</span>
            </el-button>
          </router-link>
          <router-link :to="{path: user && user.loginId && user.loginId != null ? '/contribute/add':'/login'}">
            <el-button class="sign main-bg-color">
              <img class="submit-icon" :src="$baseUrl+'img/submit1.png'"/><span class="submit-word">投稿</span></el-button>
          </router-link>
        </div>
      </div>
      <el-card class="box-card " v-for="o in categoryList" :key="o.categoryId">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="grid-content bg-purple">
              <p class="title">{{o.categoryName}}</p>
              <p class="note">{{o.note}}</p>
              <el-divider></el-divider>
              <el-tag class="tag" v-for="item in  o.tccSubCategoryDtoList" :key="item.id" type="info">
                {{item.subCategoryName}}
              </el-tag>

            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="grid-content bg-purple clearfix">
              <router-link  v-for="item1 in  o.topic" :key="item1.id"
                            :to="{path: o.categoryId == '2' ? '/question/detail':'/contribute/detail',query: { topicId: item1.id,categoryId:o.categoryId}}">
                  <p>
                    <span class="topic-title ellipsis"> {{item1.title}}</span>
                    <span class="topic-date">{{item1.updateDate | formatDate}}</span>
                  </p>
              </router-link>
                <router-link class="view-more" :to="{path:'/community/index/all',query: {categoryId:o.categoryId}}">查看更多》</router-link>
            </div>
          </el-col>
        </el-row>
      </el-card>


    </div>

  </div>

</template>

<script>
  import {Message} from "element-ui";

  export default {
    components: {},
    data() {
      return {
        title: "平行云开发者沙龙 • 成都站 2021.10.27",
        searchForm: {
          type: '1',
          keyword: ''
        },
        categoryList: [],
      }
    },
    created() {
    },
    methods: {
      getCategories: function () {
        this.getRequest('/tccTopic/getCategoryList', {}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.categoryList = resp.data.result;
              for (var i = 0; i < this.categoryList.length; i++) {
                this.getTopics(i, this.categoryList[i].categoryId);
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })

      },
      getTopics: function (index, categoryId) {
        var params = {};
        params.categoryId = categoryId;
        params.pageSize = 5;
        params.page = 1;
        if (this.searchForm.keyword != '') {
          params.keyword = this.searchForm.keyword;
        }
        this.getRequest('/tccTopic/getList', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.$set(this.categoryList[index], 'topic', resp.data.result.records)
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
    },
    mounted: function () {
      this.getCategories();
      this.$emit('setActiveIndex', "6")
    },
    beforeDestroy() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      routes() {
        return this.$store.state.routes
      }
    }
  }
</script>

